import React, { useEffect, useState } from "react";
import { Building } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

let cache = null;
export function useCompanies() {
  const [c, setC] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/companies").then((r) => { cache = r.data; setC(r.data); }).catch(() => setC({ items: [] }));
  }, []);
  return c;
}

export function CompanySwitcher() {
  const c = useCompanies();
  if (!c || (c.items || []).length < 2) return null;
  const change = (id) => { localStorage.setItem("norea_company", id); window.location.href = "/"; };
  const cur = c.items.find((x) => x.id === c.current);
  return (
    <label className="mt-3 flex items-center gap-2 text-xs" data-testid="company-switcher">
      <Building className="w-3.5 h-3.5" style={{ color: cur?.color }} />
      <select value={c.current} onChange={(e) => change(e.target.value)} className="flex-1 border border-norea-border rounded px-2 py-1 bg-white text-xs font-medium" data-testid="company-select">
        {c.items.map((x) => <option key={x.id} value={x.id}>{x.name}{x.provisoire ? " (à configurer)" : ""}</option>)}
      </select>
    </label>
  );
}

export function CompanyChecks({ email, value, disabled }) {
  const c = useCompanies();
  const [sel, setSel] = useState(value?.length ? value : ["norea"]);
  if (!c) return null;
  const toggle = async (id) => {
    const next = sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id];
    if (!next.length) return;
    try { setSel((await api.put(`/companies/users/${encodeURIComponent(email)}`, { companies: next })).data.companies); toast.success("Sociétés mises à jour"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  };
  if (disabled) return <span className="text-[11px] text-norea-textMuted">Toutes (admin)</span>;
  return (
    <div className="flex gap-1.5" data-testid={`user-companies-${email}`}>
      {c.items.map((x) => (
        <label key={x.id} className="inline-flex items-center gap-1 text-[11px]"><input type="checkbox" checked={sel.includes(x.id)} onChange={() => toggle(x.id)} data-testid={`user-company-${email}-${x.id}`} />{x.name}</label>
      ))}
    </div>
  );
}

export function BoxCompany({ box }) {
  const c = useCompanies();
  if (!c || (c.items || []).length < 2) return null;
  const set = async (id) => {
    try { await api.put(`/companies/mailbox/${box.id}`, { company_id: id }); toast.success("Société de la boîte mise à jour"); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  };
  return (
    <select defaultValue={box.company_id || "norea"} onChange={(e) => set(e.target.value)} className="border border-norea-border rounded px-2 py-1 text-xs bg-white" title="Société de cette boîte" data-testid={`mailbox-company-${box.id}`}>
      {c.items.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
    </select>
  );
}
